import { MorphemeTileGlyph } from "@-/dev.improve.haniverse.routes.nav.app._components.morpheme.tile.ui.glyph-renderer";
import { GraphemeFontGlyph } from "@-/dev.improve.haniverse.routes.nav.app._components.morpheme.grapheme.glyph.font";
import type { GraphemeGlyph } from "@-/dev.improve.haniverse.lib.morpheme.grapheme.entities";
import { cn } from "@-/com.npmjs.cn";
import { Pressable, View } from "@-/com.npmjs.react-native";
import { copyToClipboard } from "@-/dev.improve.haniverse.lib.clipboard";
import {
  ContextMenu,
  ContextMenuContent,
  ContextMenuItem,
  ContextMenuTrigger,
} from "@-/dev.improve.haniverse.components.ui.context-menu";
import { Text } from "@-/dev.improve.haniverse.components.ui.text";

export type MorphemeMnemonicsPanelMeaningTabButtonProps = {
  focused: boolean;
  front: string;
  graphemeGlyph: GraphemeGlyph;
  onPress: () => void;
};

export function MorphemeMnemonicsPanelMeaningTabButton({
  focused,
  front,
  graphemeGlyph,
  onPress,
}: MorphemeMnemonicsPanelMeaningTabButtonProps) {
  return (
    <ContextMenu>
      <ContextMenuTrigger asChild>
        <Pressable
          accessibilityLabel={`Character ${front}`}
          accessibilityState={focused ? { selected: true } : {}}
          className="size-12"
          onPress={onPress}
          // `role`, not `accessibilityRole`: the context-menu trigger contributes `role="button"`,
          // and React Native gives `role` precedence, which announced this tab as a button.
          role="tab"
        >
          <View
            className={cn(
              "h-full flex-1 items-center justify-center border-t-2",
              focused ? "border-t-black" : "mx-1.5 border-t-black/15",
            )}
          >
            <MorphemeTileGlyph
              fallback={
                <GraphemeFontGlyph
                  className={cn(
                    "text-[26px] font-semibold",
                    focused ? "text-foreground" : "text-muted-foreground",
                  )}
                  glyph={graphemeGlyph}
                />
              }
              glyph={graphemeGlyph}
              size={26}
            />
          </View>
        </Pressable>
      </ContextMenuTrigger>
      <ContextMenuContent>
        <ContextMenuItem
          onPress={() => {
            void copyToClipboard(front, { label: front });
          }}
        >
          <Text>Copy {front}</Text>
        </ContextMenuItem>
      </ContextMenuContent>
    </ContextMenu>
  );
}
